import { useState, useEffect } from 'react';
import { Container, Grid, Paper, Stack, Box, Typography } from '@mui/material';
import AuthorizeView from "@components/Authorization/AuthorizeView"
import CardInformazione from '@components/object/CardInformazione';
import Calendario from '@components/Calendario/Calendario';
import { fetchLeads } from '@api/apiLeads';
import { fetchUtenti } from '@api/apiUtenti';
import { USER_ADMIN, VALORI_SITUAZIONE } from '@config/constant';
import GraficoTorta from '@components/grafici/GraficoTorta';
import paper from 'styles/Paper.module.css'
import { PieValueType } from '@mui/x-charts';
import DateRange from '@components/object/DateRange';

type Props = {
    filteredLeads: Array<Lead>;
}
const ContatoriFasi: React.FC<Props> = (props: Props) => {

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4,  }}>
            <Grid container spacing={3} lg={12}>
                <Grid item xs={12} md={2} lg={2}>
                    <Paper className={paper.style}>
                        <CardInformazione titolo='FASE 1' valore={props.filteredLeads.filter(l => l.fase == 1).length} sottoTitolo='LEAD ACQUISITO'></CardInformazione>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={2} lg={2}>
                    <Paper className={paper.style}>
                        <CardInformazione titolo='FASE 2' valore={props.filteredLeads.filter(l => l.fase == 2).length} sottoTitolo='NUTRING'></CardInformazione>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={2} lg={2}>
                    <Paper className={paper.style}>
                        <CardInformazione titolo='FASE 3' valore={props.filteredLeads.filter(l => l.fase == 3).length} sottoTitolo='RICHIESTA CONSULENZA'></CardInformazione>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={2} lg={2}>
                    <Paper className={paper.style}>
                        <CardInformazione titolo='FASE 4' valore={props.filteredLeads.filter(l => l.fase == 4).length} sottoTitolo='CONSULENZA PRENOTATA'></CardInformazione>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={2} lg={2}>
                    <Paper className={paper.style}>
                        <CardInformazione titolo='FASE 5' valore={props.filteredLeads.filter(l => l.fase == 5).length} sottoTitolo='PROPOSTA EFFETTUATA'></CardInformazione>
                    </Paper>
                </Grid>
            </Grid>
        </Container>

    );
}

export default ContatoriFasi;